module.exports = __webpack_public_path__ + "assets/img/15.4ad2f42e.png";